import { isArray } from 'lodash';
import {
  LOCAL_STORAGE_TIEOUT_APP_IDENTIFIER,
  TIME_TO_LIVE_FOR_LOCALE_LANGUAGE_JSON,
} from 'constants/common/feature-common-utils';
import { getAllContainerDetails } from 'api/project-list-api';
import {
  getAllCountriesListFromLocalstorage,
  hasValidCountryNamesInLocalStorage,
} from '../../utils/project-utils';

/**it checks localStorage key "tieout__AllCountriesList" with its value if it exists
 * it won't be triggers /tieout/containers/all API call to fetch all the countries list(static data) and
 * if localStorage key not present it will creates key with value of response of /tieout/containers/all API call.
 * Note: this localStorage key will be updated based on the expiry value
 * @param {boolean} forceRefresh - If true, bypasses cache check and fetches fresh data (used when OPM comes back up)
 */
export const fetchAndUpdateAllCountriesList = (forceRefresh = false) => async () => {
  const countriesList = getAllCountriesListFromLocalstorage();
  const shouldFetch = forceRefresh || !(
    // if allCountryList does not exist or it has expired or doesn't have valid country names
    // then only we want to make api call.
    countriesList &&
    isArray(countriesList.data) &&
    countriesList.data.length > 0 &&
    countriesList.expiry > new Date().getTime() &&
    hasValidCountryNamesInLocalStorage() // Also refresh if only country codes exist (no names)
  );
  
  if (shouldFetch) {
    try {
      const response = await getAllContainerDetails();
      // Only store to localStorage if we have valid data
      // This ensures we retry fetching when OPM comes back up after being down
      if (response && isArray(response.data) && response.data.length > 0) {
        // append time to live with allCountriesList
        const countriesListWithTTL = {
          data: response.data,
          expiry: new Date().getTime() + TIME_TO_LIVE_FOR_LOCALE_LANGUAGE_JSON,
        };

        localStorage.setItem(
          `${LOCAL_STORAGE_TIEOUT_APP_IDENTIFIER}_AllCountriesList`,
          JSON.stringify(countriesListWithTTL),
        );
      }
    } catch (e) {
      console.error(e);
    }
  }
};

export const refreshCountriesListIfNeeded = () => async (dispatch) => {
  if (!hasValidCountryNamesInLocalStorage()) {
    await dispatch(fetchAndUpdateAllCountriesList(true));
  }
};
